/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { SNACKBAR_ALERT_DEFAULT_PROPS } from '../../shared/constants';
import { setSnackBarDisplay } from '../snackBar/snackBarActionCreator';
import { getValidationErrorMessages } from '../../utility/commonUtility';
import { showErrorAction, clearErrorAction } from "../error/errorActionCreator";
import { hideLoaderAction, showLoaderAction } from "../loader/loaderActionCreator";
import { customerPayload, ICreateCustomerRequest, IEditCustomerRequest } from '../../models/Customers/customer';
import { createNewCustomer, deleteCustomer, getAllCustomers, updateCustomer } from '../../services/customer';
import { getAllCustomersAction, removeCustomerAction, setSelectedCustomerAction } from './customerActionCreator';

export const getCustomers = async (dispatch: Function, customerPayload: customerPayload) => {
  let customers: any = [];
  let selectedCustomer: any = {};
  try {
    dispatch(showLoaderAction());
    dispatch(clearErrorAction());
    const customersResponse = await getAllCustomers(customerPayload);
    if (customersResponse.data) {
      customers = customersResponse.data;
      selectedCustomer = customers[0];
      if (customerPayload.id) {
        selectedCustomer = customers.find((customer: any) => customer.id === customerPayload.id);
      }
      dispatch(getAllCustomersAction(customers, selectedCustomer, customers.length > 0 ? false : true, customersResponse.metadata));
    }
    dispatch(hideLoaderAction());
  } catch (error: any) {
    const errorMessageDetail = getValidationErrorMessages(error);
    const errorMessage = {
      message: 'Error in fetching data: ' + errorMessageDetail
    };
    customers = [];
    selectedCustomer = {};
    dispatch(getAllCustomersAction(customers, selectedCustomer, false, { pageNumber: 1, pageSize: 50, totalCount: 0 }));
    dispatch(showErrorAction(errorMessage));
    dispatch(hideLoaderAction());
    dispatch(
      setSnackBarDisplay({
        ...SNACKBAR_ALERT_DEFAULT_PROPS,
        show: true,
        message: 'Error in Get Customer data: ' + errorMessageDetail,
        severity: 'error',
      })
    );
  }
};

export const createCustomer = async (dispatch: Function, createCustomerPayload: ICreateCustomerRequest) => {
  try {
    dispatch(showLoaderAction());
    dispatch(clearErrorAction());
    const createCustomerResponse = await createNewCustomer(createCustomerPayload);
    await getCustomers(dispatch, { pageNo: 0, pageSize: 50, searchString: "", id: createCustomerResponse.id });
    // dispatch(setSelectedCustomerAction(createCustomerResponse.data));
    dispatch(hideLoaderAction());
    return true;
  } catch (error: any) {
    const errorMessageDetail = getValidationErrorMessages(error);
    const errorMessage = {
      message: 'Error in create Customer: ' + errorMessageDetail
    };
    dispatch(showErrorAction(errorMessage));
    dispatch(hideLoaderAction());
    dispatch(
      setSnackBarDisplay({
        ...SNACKBAR_ALERT_DEFAULT_PROPS,
        show: true,
        message: 'Error in create customer: ' + errorMessageDetail,
        severity: 'error',
      })
    );
    return false;
  }
};

export const editCustomer = async (dispatch: Function, editCustomerPayload: IEditCustomerRequest) => {
  try {
    dispatch(showLoaderAction());
    dispatch(clearErrorAction());
    const editCustomerResponse = await updateCustomer(editCustomerPayload);
    await getCustomers(dispatch, { pageNo: 0, pageSize: 50, searchString: "", id: editCustomerPayload.id });
    dispatch(setSelectedCustomerAction(editCustomerResponse.data));
    dispatch(hideLoaderAction());
    return true;
  } catch (error: any) {
    const errorMessageDetail = getValidationErrorMessages(error);
    const errorMessage = {
      message: 'Error in fetching data: ' + errorMessageDetail
    };
    dispatch(showErrorAction(errorMessage));
    dispatch(hideLoaderAction());
    dispatch(
      setSnackBarDisplay({
        ...SNACKBAR_ALERT_DEFAULT_PROPS,
        show: true,
        message: 'Error in edit customer: ' + errorMessageDetail,
        severity: 'error',
      })
    );
    return false;
  }
};

export const removeCustomer = async (dispatch: Function, customerId: string) => {
  try {
    dispatch(showLoaderAction());
    dispatch(clearErrorAction());
    await deleteCustomer(customerId);
    await getCustomers(dispatch, { pageNo: 0, pageSize: 50, searchString: "" });
    dispatch(removeCustomerAction(customerId));
    dispatch(hideLoaderAction());
  } catch (error: any) {
    const errorMessageDetail = getValidationErrorMessages(error);
    const errorMessage = {
      message: 'Error in fetching data: ' + errorMessageDetail
    };
    dispatch(showErrorAction(errorMessage));
    dispatch(hideLoaderAction());
    dispatch(
      setSnackBarDisplay({
        ...SNACKBAR_ALERT_DEFAULT_PROPS,
        show: true,
        message: 'Error in Delete Customer: ' + errorMessageDetail,
        severity: 'error',
      })
    );
  }
};